import { render, staticRenderFns } from "./Remito.vue?vue&type=template&id=d9bb277c&"
import script from "./Remito.vue?vue&type=script&lang=js&"
export * from "./Remito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports